import React from 'react';
import Cookies from 'universal-cookie';
import { ActionType, reducer } from './AppReducer';
import { ITokens } from '../interfaces/';

export const storageKey = 'atiqx-id-v2';

export class AppConfig {
  accessToken = '';
  refreshToken = '';
  email = '';
}

export interface Store {
  state: AppConfig;
  setEmail: (email: string) => void;
  setTokens: (tokens: ITokens) => void;
  clearTokens: () => void;
  logout: () => void;
}

const defaultState = { ...(new Cookies().get(storageKey) ? new Cookies().get(storageKey) : new AppConfig()) };

const AppContext = React.createContext<Store>({
  state: defaultState,
  setEmail: () => undefined,
  setTokens: () => undefined,
  clearTokens: () => undefined,
  logout: () => undefined,
});

export const useAppContext: () => Store = () => React.useContext<Store>(AppContext);

export const AppProvider = ({
  children,
}: {
  children: ({ accessToken }: { accessToken: string }) => React.ReactNode;
}): JSX.Element => {
  const [state, dispatch] = React.useReducer(reducer, defaultState);

  const context: Store = {
    state,
    setEmail: (email: string) => dispatch({ type: ActionType.SET_EMAIL, payload: email }),
    setTokens: (tokens: ITokens) => dispatch({ type: ActionType.SET_TOKENS, payload: tokens }),
    clearTokens: () => dispatch({ type: ActionType.SET_TOKENS, payload: { accessToken: '', refreshToken: '' } }),
    logout: () => dispatch({ type: ActionType.LOGOUT, payload: new AppConfig() }),
  };

  return <AppContext.Provider value={context}>{children({ accessToken: state.accessToken })}</AppContext.Provider>;
};
